
// export const formatAmount = (amount, decimals = 2) => {
//   try {
//     if (amount === null || amount === undefined) return Number(0).toFixed(decimals);

//     // If amount is object like {balance: 100}
//     if (typeof amount === "object") {
//       const val = Number(amount.balance);
//       return isNaN(val) ? Number(0).toFixed(decimals) : val.toFixed(decimals);
//     }

//     // Convert string/number safely
//     const num = Number(amount);
//     return isNaN(num) ? Number(0).toFixed(decimals) : num.toFixed(decimals);

//   } catch (err) {
//     return "0.00"; // last fallback → guarantee no crash
//   }
// };


// Format amount: truncate to 2 decimals and show fixed 2 decimals
export const formatAmount = (amount, decimals = 2) => {
  try {
    if (amount === null || amount === undefined) return (0).toFixed(decimals);

    let num;
    if (typeof amount === "object") {
      num = Number(amount.balance);
    } else {
      num = Number(amount);
    }

    if (isNaN(num)) return (0).toFixed(decimals);

    // Truncate instead of rounding
    const truncated = Math.floor(num * 10 ** decimals) / 10 ** decimals;
    return truncated.toFixed(decimals);

  } catch (err) {
    return (0).toFixed(decimals);
  }
};

